module.exports = __webpack_public_path__ + "static/media/bg_page_header.dfac4597.jpg";